// extracted by mini-css-extract-plugin
export var measureBox = "_3u-0";